// Auto generated file, do not manually modify!
// com.hotpads.satellite.client.message.type.SatelliteUiTreatmentType

export enum SatelliteUiTreatmentType {
  HIGH_PRIORITY = 'HIGH_PRIORITY',
  HIGH_PRIORITY_W_LOGO = 'HIGH_PRIORITY_W_LOGO',
  LOW_PRIORITY = 'LOW_PRIORITY',
}

export const SatelliteUiTreatmentType_values = [
  SatelliteUiTreatmentType.HIGH_PRIORITY,
  SatelliteUiTreatmentType.HIGH_PRIORITY_W_LOGO,
  SatelliteUiTreatmentType.LOW_PRIORITY,
] as const;
